const subscriptionsRoutes = [

    {
        path: '/subscription-requests',
        name: 'SubscriptionRequestsPage',
        component: () => import('../views/subscriptions/SubscriptionRequestsComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'subscriptions',
        },
    },

];

export default subscriptionsRoutes;
